import { render } from "./Enrol.vue?vue&type=template&id=7bb07ec2"
import script from "./Enrol.vue?vue&type=script&lang=js"
export * from "./Enrol.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ruwan/projects/eopp/eopp-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__